import { Component, inject, linkedSignal, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideLayoutDashboard, lucideNotebookText } from '@ng-icons/lucide';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmDialogFooter, HlmDialogHeader, HlmDialogTitle } from '@spartan-ng/helm/dialog';
import { HlmIcon } from '@spartan-ng/helm/icon';
import { HlmInput } from '@spartan-ng/helm/input';
import { HlmSeparator } from '@spartan-ng/helm/separator';

import { ModuleStore } from '../../../../référentiel-métier-parcours/parcours-module/store/module.store';
import { AlerteComponent } from '../../../../shared/components/alerte/alerte.component';
import { Sequence } from '../../../models/séquence.model';

@Component({
  selector: 'app-dialog-confirm-delete',
  imports: [
    HlmDialogHeader,
    HlmDialogTitle,
    HlmDialogFooter,
    HlmButton,
    NgIcon,
    HlmIcon,
    HlmSeparator,
    AlerteComponent,
    FormsModule,
    HlmInput,
  ],
  templateUrl: './dialog-confirm-delete.component.html',
  providers: [provideIcons({ lucideLayoutDashboard, lucideNotebookText })],
})
export class DialogConfirmDeleteComponent {
  readonly #dialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef);
  readonly #dialogContext = injectBrnDialogContext<{ sequence: Sequence }>();
  readonly #moduleStore = inject(ModuleStore);

  readonly CONFIRMATION_SUPPRESSION_TEXTE = 'SUPPRIMER';

  readonly sequence = this.#dialogContext.sequence;

  readonly module = linkedSignal(() => this.#moduleStore.selectedEntity());

  supprimer = model('');

  public close() {
    if (this.supprimer() === this.CONFIRMATION_SUPPRESSION_TEXTE) {
      this.#dialogRef.close(true);
    }
  }
}
